import { useState } from "react";
import "./crypto-faq.css";

const FAQS = [
	{
		idx: 0,
		title:
			"Чем web3 дизайн отличается от традиционного дизайна вебсайтов и приложений?",
		content:
			"Web3 дизайн учитывает специфику блокчейн-технологий: работу с криптокошельками, смарт-контрактами и децентрализованными системами. Его главная задача — упростить сложные процессы, обеспечить безопасность, прозрачность и удобство для пользователей, а не просто создать красивый интерфейс",
	},
	{
		idx: 1,
		title: "Сколько стоит создать web3 / crypto продукт?",
		content:
			"Стоимость создания Web3/криптопродукта зависит от его сложности, объема функционала, этапов разработки и требований к дизайну. Чтобы определить точную стоимость, напишите нам — обсудим ваш проект и подготовим персональное предложение",
	},
	{
		idx: 2,
		title: "Сколько времени займет проектирование web3 / crypto продукта?",
		content:
			"Сроки проектирования Web3/криптопродукта зависят от сложности проекта, ваших требований к функционалу и дизайну. В среднем, процесс занимает от нескольких недель (для быстрых MVP) до нескольких месяцев — точное время определим после обсуждения деталей вашего проекта.",
	},
	{
		idx: 3,
		title:
			"Как сделать Web3 продукты удобными для пользователей, не знакомых с блокчейном?",
		content:
			"Чтобы сделать Web3 продукты удобными для новичков, важно упростить интерфейс, добавить понятные подсказки и инструкции, сосредоточиться на безопасности и прозрачности процессов",
	},
	{
		idx: 4,
		title: "С чего начать работу над проектом в Web3?",
		content:
			"Начните с определения целей и задач продукта, определите потребности целевой аудитории и соберите основные требования. Мы поможем вам на каждом этапе, начиная с обсуждения идеи и подготовки плана.",
	},
	{
		idx: 5,
		title: "Как заказать дизайн для моего Web3 проекта?",
		content:
			"Чтобы заказать дизайн для вашего Web3 проекта, свяжитесь с нами через форму обратной связи на сайте. Мы обсудим ваши цели, задачи и детали проекта и предложим оптимальное решение",
	},
];

function CryptoFaq() {
	const [currentDD, setCurrentDD] = useState(undefined);

	function handleClick(idx) {
		if (currentDD === idx) {
			setCurrentDD(undefined);
		} else {
			setCurrentDD(idx);
		}
	}

	return (
		<div className="crypto__faq">
			<div className="container">
				<h2 className="h2">Часто задаваемые вопросы</h2>
				<div className="faq__container">
					{FAQS.map((item) => (
						<div
							onClick={() => handleClick(item.idx)}
							key={item.idx}
							className={
								currentDD === item.idx ? "faqitem faqitem--active" : "faqitem"
							}
						>
							<div className="faqtitle">
								{item.title}
								<div className="faqcorss" />
							</div>

							<div className="faqtext">{item.content}</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default CryptoFaq;
